<script>
    import REST from '../RESTClass.js';
    import { watchResize } from "svelte-watch-resize";
    import { setMoverVisibility } from '../Utils';

    import Card from '../Components/Card/Card.svelte';
    import Mover from '../Components/Mover/Mover.svelte';

    let gospelData;
    let moverVisible = true;

    const API = new REST();
    API.getGospelForArtists()
        .then(data => gospelData = data);

</script>

<section class="gospel">
    <h2 class="padded">Słowo do artystów</h2>
    <div use:watchResize={node => moverVisible = setMoverVisibility(node)} class="quotes padded">
        {#if gospelData}
            {#each gospelData as entry}
                <Card
                    type="quote"
                    content={{
                        description: entry.shortage,
                        id: entry.id
                    }}
                    props={{
                        spaced: true
                    }}
                />
            {/each}
        {/if}
    </div>
    <Mover 
        props={{
            range: 300,
            visible: moverVisible
        }}
    />
</section>

<style type="text/scss">
    h2 {
        color: #c2ae8d;
        font-family: 'Rufina', serif;
        font-size: 18px;
        margin: 1.2rem 0;
        text-transform: uppercase;
    }

    .quotes {
        display: flex;
        overflow-x: scroll;
        -ms-overflow-style: none;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }
</style>